import React from 'react';
import EditBill from '../Forms/EditBill';

const BillLines = (props) => {
    return (
        <div style={{ display: 'flex', width: '100%', border: 'none' }}>
           <EditBill
                data={props.data}
                onSaved={props.onSaved}
                onCancel={props.onCancel}
                workflowId={props.workflowId}
                canEditWorkflow3={props.canEditWorkflow3}
            />
        </div>
    );
};

export default BillLines;
